"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.URLField = void 0;
const joi_1 = __importDefault(require("joi"));
const lodash_1 = require("lodash");
const field_types_1 = require("../../types/field_types");
const datasheet_1 = require("../datasheet");
const text_base_field_1 = require("./text_base_field");
class URLField extends text_base_field_1.TextBaseField {
    constructor(field, state) {
        super(field, state);
        this.field = field;
        this.state = state;
    }
    static defaultProperty() {
        return {
            isRecogURLFlag: false,
        };
    }
    cellValueToApiStringValue(cellValue) {
        const result = this.cellValueToString(cellValue);
        if (result === null) {
            return '';
        }
        return result;
    }
    cellValueToURL(cellValue) {
        if (cellValue === null) {
            return '';
        }
        const cv = [cellValue].flat();
        return cv.map(seg => (seg === null || seg === void 0 ? void 0 : seg.text) || (seg === null || seg === void 0 ? void 0 : seg.title)).join('') || null;
    }
    cellValueToString(cellValue) {
        if (cellValue === null) {
            return null;
        }
        const cv = [cellValue].flat();
        return cv.map(seg => (seg === null || seg === void 0 ? void 0 : seg.title) || (seg === null || seg === void 0 ? void 0 : seg.text)).join('') || null;
    }
    validateProperty() {
        return URLField.propertySchema.validate(this.field.property);
    }
    validateCellValue(cv) {
        return URLField.cellValueSchema.validate(cv);
    }
    cellValueToApiStandardValue(cellValue) {
        if (cellValue == null) {
            return null;
        }
        const cv = (0, lodash_1.first)([cellValue].flat());
        if (!cv) {
            return null;
        }
        return {
            title: cv.title || cv.text,
            text: cv.text,
            favicon: cv.favicon || ''
        };
    }
    static createDefault(fieldMap) {
        return {
            id: datasheet_1.DatasheetActions.getNewFieldId(fieldMap),
            name: datasheet_1.DatasheetActions.getDefaultFieldName(fieldMap),
            type: field_types_1.FieldType.URL,
            property: this.defaultProperty(),
        };
    }
}
exports.URLField = URLField;
URLField.cellValueSchema = joi_1.default.array().items(joi_1.default.object({
    text: joi_1.default.string().allow('').required(),
    type: joi_1.default.number().required(),
    link: joi_1.default.string(),
    title: joi_1.default.string(),
    favicon: joi_1.default.string(),
}).required()).allow(null).required();
URLField.propertySchema = joi_1.default.object({
    isRecogURLFlag: joi_1.default.boolean(),
});
//# sourceMappingURL=url_field.js.map